import { render } from "./fullscreen-loader-container.vue?vue&type=template&id=22d62b3b"
import script from "./fullscreen-loader-container.vue?vue&type=script&lang=js"
export * from "./fullscreen-loader-container.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__